// extracted by mini-css-extract-plugin
export default {"errorPage_title":"ErrorPage_errorPage_title__rVZCv"};